<template>
  <v-menu>
    <template #activator="{ on, attrs }">
      <v-btn
        color="accent"
        small
        :loading="isLoading"
        :disabled="isLoading"
        v-bind="attrs"
        v-on="on"
      >
        {{ getStatusLabel }}
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-for="estatus in filteredEstatusDerivacionesByRole"
        :key="estatus.id"
        selectable
        @click="changeEstatusDerivacion(estatus.id)"
      >
        <v-list-item-title>{{ estatus.title }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
import ROLES from '../roles';

export default {
  props: {
    derivacion: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isLoading: false,
    };
  },

  computed: {
    ...mapGetters({
      selectedRole: 'getSelectedRole',
    }),
    ...mapGetters('estatusDerivaciones', {
      estatusDerivaciones: 'getEstatusDerivaciones',
    }),
    ...mapGetters('derivaciones', {
      derivaciones: 'getDerivaciones',
    }),

    getStatusLabel() {
      if (this.derivacion.fk_idCatEstatus) {
        return this.estatusDerivaciones.find(
          (item) => item.id === this.derivacion.fk_idCatEstatus,
        ).title;
      }

      return 'Sin estatus';
    },

    filteredEstatusDerivacionesByRole() {
      const EVALUADO_STATUS = 3;

      if (!this.selectedRole || this.selectedRole === ROLES.DIRECTOR_GENERAL || this.selectedRole === ROLES.DIRECTOR_AREA) {
        return this.estatusDerivaciones;
      }

      return this.estatusDerivaciones.filter(
        (estatus) => estatus.id === EVALUADO_STATUS,
      );
    },
  },

  methods: {
    ...mapActions('derivaciones', ['updateDerivacion', 'updateEstatusDerivacion', 'fetchDerivacionesByArea']),

    async changeEstatusDerivacion(statusId) {
      this.isLoading = true;

      await this.updateDerivacion({
        fk_idProgramacion: this.derivacion.fk_idProgramacion,
        fechaAtendio: moment().format('MM/DD/YYYY'),
        idDerivacion: this.derivacion.idDerivacion,
        oficioSolicitud: this.derivacion.oficioSolicitud,
        fechaOficioSolicitud: this.derivacion.fechaOficioSolicitud ? moment(this.derivacion.fechaOficioSolicitud).format('DD/MM/YYYY') : moment().format('MM/DD/YYYY'),
        fk_idEquipoApplication: this.derivacion.fk_idEquipoApplication,
        fk_idCatEstatus: statusId,
        oficioRespuesta: this.derivacion.oficioRespuesta,
        fechaOficioRespuesta: this.derivacion.fechaOficioRespuesta ? moment(this.derivacion.fechaOficioRespuesta).format('DD/MM/YYYY') : moment().format('MM/DD/YYYY'),
        resultado: this.derivacion.resultado,
        fechaCerro: this.derivacion.fechaCerro,
        observaciones: this.derivacion.observaciones,
      });

      const index = this.derivaciones.findIndex(
        (derivacion) => derivacion.idDerivacion === this.derivacion.idDerivacion,
      );

      if (index > -1) {
        this.derivaciones[index].fk_idCatEstatus = statusId;
      }

      this.isLoading = false;
    },
  },
};
</script>
